/**
 * Hover animation for line graph line hovering
 */
export const spring = {
    type: 'spring',
    stiffness: 700,
    damping: 60
};
